import React from "react";
import { Route, Routes } from "react-router-dom";
import ConnectionLayout from "../layout/connection/ConnectionLayout";
import ConnectionType from "../layout/connection/ConnectionType";
import AddConnection from "../layout/connection/AddConnection";
function ConnectionPage() {
  return (
    <>
      <Routes>
        <Route path="/" element={<ConnectionLayout />} />
        <Route path="/add" element={<AddConnection />} />
        <Route path="/update/:id" element={<AddConnection />} />
        <Route path="/type/:id" element={<ConnectionType />} />
      </Routes>
    </>
  );
}

export default ConnectionPage;
